// MED-1171: Licence promotion module. Contract source: medecine360-bff MR !211
// (ticket MED-1290 + its MED-1171 follow-up commit — confirmed against the
// real merged response shape, not assumed).

export interface PromotionTranslations {
  fr: string;
  en: string;
  ar: string;
}

// A promotion code as returned by GET /admin/promotion/codes and
// GET /onboarding/promotions, with dates/active taken from its
// most-recent-or-active validity period (if any).
export interface PromotionCode {
  // The promotion *code*'s id — NOT what assign/edit-period actions need.
  id: number;
  promotionCode: string;
  rebate: number | null;
  translations: PromotionTranslations;
  startDate: string | null;
  endDate: string | null;
  active: boolean;
  // The backing licence_promotion *period*'s id (absent — not `null` — if
  // the code has no period yet: the BFF DTO is @JsonInclude(NON_NULL), so a
  // null value drops the key from the JSON entirely rather than sending
  // `"promotionId": null`). This — not `id` above — is the `promotionKey`
  // that assignPromotion/unassignPromotion/updatePromotionPeriod must send:
  // a code can have several periods over time, so the code id alone can't
  // disambiguate which one to assign/edit.
  promotionId?: number;
  facilitiesCount: number;
}

// GET /promotion/facility/{facilityId} — a promotion active today for a facility.
export interface ActivePromotion {
  promotionCode: string | null;
  rebate: number | null;
  startDate: string | number[] | null;
  endDate: string | number[] | null;
  translatedMessage: string | null;
  // MED-1583: the facility licence's monthly amount with this promotion
  // active today, computed by the API; 0 for a FREE_TRIAL.
  discountedMonthlyAmount?: number | null;
}

export const FREE_TRIAL_PROMOTION_CODE = "FREE_TRIAL";

// POST /admin/promotion/code
export interface PromotionCodeCreateRequest {
  promotionCode: string;
  rebate: number | null;
  translations: PromotionTranslations;
}

// POST /admin/promotion — creates a validity period for an existing code.
export interface PromotionPeriodCreateRequest {
  promotionCodeKey: string;
  startDate: string;
  endDate: string;
}

// POST /admin/promotion/assign
export interface PromotionAssignRequest {
  promotionKey: number;
  facilityId: number;
}

// POST /onboarding/promotions/apply
export interface OnboardingPromotionApplyRequest {
  facilityId: number;
  promotionCode: string;
  startDate: string;
  endDate: string;
}

// Facility assigned to a promotion period, shown in the Promotion Details view.
// GET /admin/promotion/{promotionId}/facilities
export interface PromotionFacilityAssignment {
  facilityId: number;
  facilityName: string;
  startDate: string;
  endDate: string;
}

// POST /admin/promotion/unassign
export interface PromotionUnassignRequest {
  promotionKey: number;
  facilityId: number;
}

// PUT /admin/promotion/{promotionId}
export interface PromotionPeriodUpdateRequest {
  startDate: string;
  endDate: string;
}
